var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgDiagonalBottom = function SvgDiagonalBottom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1600 337",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#diagonal-bottom_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1600L0 337V0Z",
    fill: "#F3FFCE"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#006E61",
    strokeWidth: 3,
    d: "m-.309 335.532 1599.999-337"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 388,
    cy: 253,
    r: 10,
    fill: "#006E61"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1177,
    cy: 87,
    r: 10,
    fill: "#006E61"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "diagonal-bottom_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1600v337H0z"
  })))));
};

export { SvgDiagonalBottom as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTYwMCAzMzciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgY2xpcC1wYXRoPSJ1cmwoI2EpIj48cGF0aCBkPSJNMCAwaDE2MDBMMCAzMzdWMFoiIGZpbGw9IiNGM0ZGQ0UiLz48cGF0aCBzdHJva2U9IiMwMDZFNjEiIHN0cm9rZS13aWR0aD0iMyIgZD0ibS0uMzA5IDMzNS41MzIgMTU5OS45OTktMzM3Ii8+PGNpcmNsZSBjeD0iMzg4IiBjeT0iMjUzIiByPSIxMCIgZmlsbD0iIzAwNkU2MSIvPjxjaXJjbGUgY3g9IjExNzciIGN5PSI4NyIgcj0iMTAiIGZpbGw9IiMwMDZFNjEiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJhIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMCAwaDE2MDB2MzM3SDB6Ii8+PC9jbGlwUGF0aD48L2RlZnM+PC9zdmc+";